import Tr from 'translations/Translations';

const PrimaryTenderVariant = {
	VARIANT_1: "variant_1",
	VARIANT_2: "variant_2",
	VARIANT_3: "variant_3",
}

export const PrimaryTenderVariantTr = {
	[PrimaryTenderVariant.VARIANT_1]: Tr("primarytendervariant.variant_1"),
	[PrimaryTenderVariant.VARIANT_2]: Tr("primarytendervariant.variant_2"),
	[PrimaryTenderVariant.VARIANT_3]: Tr("primarytendervariant.variant_3")
}

export default PrimaryTenderVariant;
